/**
 *
 */
import WrapperComponent from "./src/components/layout/WrapperComponent";
import "./src/styles/global.scss";

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = WrapperComponent;
